/**
 * Avatar gradient presets
 */
export const AVATAR_GRADIENTS = [
	'linear-gradient(135deg, #22d3ee 0%, #0891b2 100%)', // Cyan
	'linear-gradient(135deg, #a78bfa 0%, #7c3aed 100%)', // Purple
	'linear-gradient(135deg, #34d399 0%, #059669 100%)', // Emerald
	'linear-gradient(135deg, #f472b6 0%, #db2777 100%)', // Pink
	'linear-gradient(135deg, #fbbf24 0%, #d97706 100%)', // Amber
	'linear-gradient(135deg, #60a5fa 0%, #2563eb 100%)', // Blue
	'linear-gradient(135deg, #f87171 0%, #dc2626 100%)', // Red
	'linear-gradient(135deg, #4ade80 0%, #16a34a 100%)', // Green
] as const;

/**
 * Generate initials from a full name
 * "Mike Agbogo" → "MA"
 * "Super Admin" → "SU"
 * "John" → "JO"
 */
export const getInitials = (name: string): string => {
	if (!name || typeof name !== 'string') return '?';

	const trimmed = name.trim();
	if (!trimmed) return '?';

	const words = trimmed.split(/\s+/).filter(Boolean);

	if (words.length === 0) return '?';

	if (words.length === 1) {
		// Single word: take first two characters
		return words[0].substring(0, 2).toUpperCase();
	}

	// Multiple words: take first character of first two words
	return (words[0][0] + words[1][0]).toUpperCase();
};

/**
 * Simple hash function for consistent gradient selection
 */
const hashString = (str: string): number => {
	let hash = 0;
	for (let i = 0; i < str.length; i++) {
		const char = str.charCodeAt(i);
		hash = (hash << 5) - hash + char;
		hash = hash & hash; // Convert to 32bit integer
	}
	return Math.abs(hash);
};

/**
 * Get a consistent gradient based on the user's name
 */
export const getGradientForName = (name: string): string => {
	if (!name || typeof name !== 'string') {
		return AVATAR_GRADIENTS[0];
	}

	const hash = hashString(name.toLowerCase().trim());
	const index = hash % AVATAR_GRADIENTS.length;
	return AVATAR_GRADIENTS[index];
};

/**
 * Avatar size mappings in pixels
 */
export const AVATAR_SIZE_MAP = {
	small: 32,
	medium: 40,
	large: 48,
} as const;

/**
 * Status indicator size mappings
 */
export const STATUS_SIZE_MAP = {
	small: 8,
	medium: 10,
	large: 12,
} as const;
